'use strict';

angular.module('changePasswordController', [])

.controller('ChangePasswordController', ['appInfo', '$scope', '$rootScope', 'BuyerService',
    function (appInfo, $scope, $rootScope, BuyerService) {    
    
    $scope.page = 'changePassword';
    $scope.buyerAccess = {
        username: $rootScope.username,
        password: ''
    };

    $scope.changePassword = function() {
        if(!$scope.buyerAccess.password) {
            alert('Please type in new password.');
            return;
        }
        $rootScope.loading = true;
        BuyerService.chagnePassword($scope.buyerAccess)
        .then(function(data){
            alert('Your password has been updated.');
        })
        .catch(function(err){
            console.log(err);
        })
        .finally(function(err){
            $rootScope.loading = false;
        }); 
    }

}]);